export default {
  label: "Asset Management",
  tabs: {
    assets: {
      label: "Assets",
      assetList: "Asset List",
      asset: "Asset",
      newAsset: "New Asset",
      editAsset: "Edit Asset",
      createAsset: {
        label: "Create Asset",
        assetDescriptor: "Asset Descriptor",
      },

      noAssetsCreatedYet: "No assets created yet",
      createFirstAsset: "Create your first Asset",
      createAssetHelperText: "Assets you create show up here with their status, model, and deployment group.",
      detailsOverview: {
        assetInformation: "Asset Information",
        relatedAssets: "Related Assets",
        assetType: "Asset Type",
        assetModel: "Asset Model",
        serialNo: "Serial No",
        parentAsset: "Parent Asset",
        childAssets: "Child Assets",
        childDevices: "Child Devices",
      },
    },
    assetGroups: {
      label: "Asset Groups",
      list: "Asset List",
      activities: "Activities",
      newAssetGroup: "New Asset Group",
      sort: {
        labelAsc: "ASC",
        labelDesc: "DESC",
      },
    },
    assetTags: {
      title: "Tags",
      createOrSelectTags: "Create or select tags",
      updateTags: "Update Tags",
    },
    assetTypes: {
      label: "Asset Types",
      labelWithCount: "Asset Types ({count})",
      newAssetType: "New Asset Type",
      editAssetType: "Update Asset Type",
      noTypeSelected: "Select a type from the list to view details",
      createAssetType: "Create Asset Type",
      createFirstAssetType: "Create your first Asset Type",
      createAssetTypeHelperText: "Asset Types you create will show up here.",
      noAttributesAssigned: "No attributes assigned",
      addAssetType: "Add Asset Type",
      deleteAssetType: {
        title: "Delete Asset Type",
        message: "Are you sure you want to delete the selected Asset Type? This can not be undone.",
      },
      noAssetTypesCreatedYet: "No Asset Types Created Yet.",
      tabs: {
        assetTypeTree: {
          label: "Hierarchy",
          errorLoadingHierarchy: "Error loading hierarchy",
        },
        models: {
          label: "Models",
          newAssetModel: "New Asset Model",
          updateAssetModel: "Update Asset Model",
          assetModelDetailsView: "Asset Model Details",
          modelDeleteErrorMessage: "Asset model could not be deleted. Please try again or contact support.",
          hierarchy: {
            label: "Hierarchy",
            errorLoadingHierarchy: "Error loading hierarchy",
            includedDevices: "Included devices",
            includedAssets: "Included assets",
          },
          attributes: {
            noDefaultValue: "No default value",
          },
          singularModel: "Model",
          modelForm: {
            selected: "selected",
            searchAttributeSets: "Search Attribute Sets...",
            selectedSets: "Selected Sets",
          },
          editAssetModelError: {
            title: "Asset Model can not be edited",

            editAssetModelErrorMessage:
              "Please make sure that you only edit Asset Models that have no Assets assigned!",
          },
          createModel: "Create Model",
          createFirstAssetModel: "Create your first Asset Model",
          createAssetModelHelperText: "Asset models you create to this type will show up here.",
          noAssetModelsCreatedYet: "No Asset Models Created Yet",
          assetAttributeSetExplaination:
            "Choose the attribute sets to display for instances of this model version. You can enter values now or during instance creation, and all values can be updated later for each instance.",
        },
        assets: {
          noAssetsOrModelsYet: "No Assets exist for this Asset Type yet",
        },
      },
      deleteAssetTypeWithModelsError: {
        title: "Asset Type can not be deleted",
        deleteAssetTypeErrorMessage: "Please make sure that you only delete AssetTypes that have no Models assigned!",
      },
      editAssetTypeWithModelsError: {
        title: "Asset Type can not be edited",
        editAssetTypeErrorMessage: "Please make sure that you only edit AssetTypes that have no Models assigned!",
      },
      deleteAssetTypeError: {
        title: "Asset Type can not be deleted",
        deleteAssetTypeErrorMessage: "Please make sure that you only delete AssetTypes that have no Models assigned!",
      },
      editAssetTypeError: {
        title: "Asset Type can not be edited",
        editAssetTypeErrorMessage: "Please make sure that you only edit AssetTypes that have no Assets assigned!",
      },
      attributeValidationError: {
        generalMessage: "Validation error: The default value does not conform to requirements",
        dataTypeError: "Default value does not match the required data type",
      },
      attributeValidationSuccess: {
        defaultValueSaved: "Default values saved successfully",
      },
      deleteAssetModelError: {
        title: "Asset Model can not be deleted",
        deleteAssetModelHasAssetsError: {
          deleteAssetModelWarningMessagePluralModel:
            "You can not delete these Asset Models if they have Assets assigned to them. The following Models have Assets assigned to them:",
          deleteAssetModelWarningMessageSingularModel:
            "You can not delete an Asset Model if it has Assets assigned to it. The following Model has Assets assigned to it:",
        },
        genericDeleteAssetModelError:
          "An error occurred while trying to delete the selected Asset Model(s). Please try again.",
        warningModal: {
          title: "Delete Asset Model(s)",
          titleSingular: "Delete Asset Model",
          titlePlural: "Delete Asset Models",
          message: "Are you sure you want to delete the selected Asset Model(s)? This can not be undone.",
          messageSingular: "Are you sure you want to delete the selected Asset Model? This can not be undone.",
          messagePlural: "Are you sure you want to delete the selected Asset Models? This can not be undone.",
        },
      },
      resetToDefaultValue: "Reset to default value",
    },
    assetDetails: {
      label: "Asset details",
      assetInformation: "Asset Information",
      relatedAssets: "Related Assets",
      childAssets: "Child Assets",
      parentAsset: "Parent Asset",
      childDevices: "Child Devices",
      fcsSetUp: {
        noChildAssetsAssignedMessage:
          "All existing instances are either already assigned to a parent, or their child assignments are incomplete.",
        assignDeviceModal: {
          title: "Assign Device",
          label: "Select Device",
        },
        assignAssetModal: {
          title: "Assign Asset",
          label: "Select Asset",
        },
        pairingComplete: "Pairing complete",
        pairingInComplete: "Pairing incomplete",
        deviceAssigned: "Assigned",
        deviceNotAssigned: "Not Assigned",
        noTreeDefined: "There is no tree hierarchy defined for this Asset Model",
        noDeviceAssigned: "No device has been assigned yet. Click the button bellow to change it.",
      },
      attributes: {
        noData: "No Available Asset Attributes Data Found",
        validationError: {
          generalMessage: "Validation error: The attribute value does not conform to requirements",
          dataTypeError: "Attribute value does not match the required data type",
        },
        saveSuccess: "Attribute values saved successfully",
        edit: "Edit",
      },
    },
    assetAttributeFieldsAndSets: {
      label: "Attribute Fields & Sets",
      assetAttributes: {
        formLabels: {
          attributeName: "Attribute Name",
          attributeFields: "Attribute Fields",
          measurementTooltip:
            "Choose whether this attribute represents a measurable quantity. If yes, you'll select a measurement type with predefined units. If no, define a custom field with a basic data type (e.g., text, number).",
        },
        deleteAssetAttribute: {
          title: "Delete Attribute Field",
          deleteMessage:
            "Are you sure you want to delete it? This action won’t affect any device or asset models and their instances.",
          assignedToModelsMessage:
            "NOTE: Some assets or devices models have assigned this attribute field for displaying attribute values of their instances. Deleting this attribute field will affect all those instances. Are you sure you want to delete it?",
          deleteAssetAttributeError: {
            title: "Attribute Field can not be deleted",
            deleteAttributeGenericErrorMessage:
              "An error occurred while trying to delete the selected Attribute Field. Please try again.",
          },
        },
        validationRules: {
          name: {
            alreadyExists: "Attribute name already exists",
          },
        },
        validationError: {
          generalMessage: "Validation error: The input value does not conform to the requirements",
          dataTypeError: "Input value does not match the required data type",
        },
        noAssetAttributeDescription: "No Asset Attribute Description",
      },
      assetAttributeSets: {
        label: "Attribute Sets",
        createAttributeSet: "Create Attribute Set",
        editAssetAttributeSet: "Edit Attribute Set",
        addAssetAttributeSet: "Add Asset Attribute Set",
        createFirstAttributeSet: "Create your first Attribute Set",
        createAttributeSetHelperText:
          "Attribute sets you create show up here. You’ll then be able to start creating and managing attribute fields.",
        deleteAttributeSet: {
          title: "Delete Attribute Set",
          deleteMessage:
            "Are you sure you want to delete it? This action won't affect any device or asset models and their instances.",
          deleteAttributeSetError: {
            title: "Error deleting Attribute Set",
            message: "An error occured when trying to delete the attribute set. Please try again.",
          },
          assignedToModelsWarningMessage:
            "NOTE: Some models have assigned this set for displaying attribute values of their instances. Deleting this set will affect all those instances. Are you sure you want to delete it?",
        },
      },
      noAssetAttributeDescription: "No Asset Attribute Description",
    },
  },
  deleteAssets: {
    label: "Delete Assets",
    message: "Are you sure you want to delete the selected asset(s)? This can not be undone.",
    assetsNotDeletedLabel: "Asset(s) could not be deleted",
    assetsWithChildrenOrParentsMessage:
      "The following asset(s) could not be deleted due to existing parent or children:",
    errorDeleteAssetsTitle: "Error deleting asset(s)",
    errorDeleteAssetsMessage: "An error occurred while trying to delete the selected asset(s). Please try again.",
  },
};
